/**
 * Where an exercise can be done, as a short phrase — VH-136.
 *
 * Three states, and all three have to read as answers rather than as missing
 * data. An empty space on a card looks like something failed to load, so
 * "nowhere yet" is said out loud.
 *
 *   places given   -> "Avaloq Manegg, Camper van"
 *   no equipment   -> handled by the caller via `location_independent`
 *   empty list     -> "No location yet"
 *
 * The backend deliberately distinguishes the last two: both arrive as an empty
 * array, and only `location_independent` tells them apart.
 *
 * Capped because an exercise possible at every gym would otherwise push the
 * rest of the card off a phone screen.
 */
export const formatPlaces = (places, t, cap = 2) => {
  if (!places || places.length === 0) return t('exercises.nowhere')
  const names = places.map((p) => p.name)
  if (names.length <= cap) return names.join(', ')
  return t('exercises.placesAndMore', {
    places: names.slice(0, cap).join(', '),
    count: names.length - cap,
  })
}

export default formatPlaces
